import { render, staticRenderFns } from "./ElectionMembers.vue?vue&type=template&id=5539ed65&scoped=true"
import script from "./ElectionMembers.vue?vue&type=script&lang=js"
export * from "./ElectionMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539ed65",
  null
  
)

export default component.exports